import React, { useState, useEffect, useRef } from 'react';
import {
  Layout,
  Button,
  Drawer,
  Form,
  Select,
  Col,
  Row,
  DatePicker,
  TimePicker,
  Input,
} from 'antd';
import Sidebar from './Component/Layout/Sidebar';
import axios from 'axios';
import moment from 'moment';

import { useNavigate, useLocation } from 'react-router-dom';

import { locationUser, setAMSToken } from './Redux/action/userActions.js';
import CustomHeader from './Component/Layout/Header';
import Drawer_Form from './Drawer_Form.js';
import KeycloakManager from './utils/keyCloakManager';
import { handleLogOut } from './utils/clearCache';
import {
  dataUser,
  allLocationWithShortName,
  dataLocation,
} from './Component/Helpers/util.js';
import { getLocationNameById } from './utils/getLocationNameById.js';

import { toast } from 'react-toastify';
import mixpanel from 'mixpanel-browser';
// import ParkingSlots from './AncillaryForm/parkingSlots';
import ParkingSlots from './Component/AncillaryForm/parkingSlots';
import MealPlanServiceRequest from './Component/AncillaryForm/mealPlanServiceRequest';
import Courier from './Component/AncillaryForm/courier';
import SpaceRequire from './Component/AncillaryForm/spaceRequireForm';
import DailyShuttleServiceRequest from './Component/AncillaryForm/dailyShuttleServiceRequest';

import Other from './Component/AncillaryForm/otherForm';
import InternetService from './Component/AncillaryForm/internetService';
import ItRental from './Component/AncillaryForm/itRental';
import CreateRoomBooking from './Component/RoomCommon/createRoomBooking';
import ExtendedWorking from './Component/AncillaryForm/extendedWorking';
import ManPowerRequest from './Component/AncillaryForm/manpowerForm';
import PublicWorking from './Component/AncillaryForm/publicWorking';
import PrinterScanner from './Component/AncillaryForm/printerScanner';
import CracheCareServiceRequest from './Component/AncillaryForm/cracheCareServiceRequest.js';
import ParamediceServiceRequest from './Component/AncillaryForm/paramedicsServiceRequest';
import GymTrainerServiceRequest from './Component/AncillaryForm/gymTrainerServiceRequest.js';

import LightGrid from './Component/LightGrid/LightGrid.js';
import FeedbackRating from './feedbackRating.js';

import './Component/AncillaryForm/form.css';
import SkyWatch from './Component/SkyWatch.js';

import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import SwOffCanvas from './Component/Common/SwOffCanvas/SwOffCanvas.js';
import SwModal from './Component/Common/SwModal/SwModal.js';
import SwButton from './Component/Common/SwButtons/SwButtons.js';
import AntDDatePicker from './Component/Common/AntDDateTimePicker/AntDDatePicker.js';
import AntDTimePicker from './Component/Common/AntDDateTimePicker/AntDTimePicker.js';
import { Tabs, Tab } from 'react-bootstrap';
import ExtendedV2 from './Component/ExtendedV2/ExtendedV2.js';

const { Content } = Layout;
const Option = Select;
const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);

let ManageApproval =
  UserObj && UserObj.role_data?.find(element => element.service_id == '23');
let ManageAncillary =
  UserObj && UserObj.role_data?.find(element => element.service_id == '27');

var LocationObj = JSON.parse(dataLocation());

const crecheCareLocationAccess = LocationObj.includes(30);

// const showExtendedBookingHoursForDlf = LocationObj.includes(113);

const paramedicsLocationAccess = LocationObj.some(id => [30, 34].includes(id));
const gymWithTrainerLocationAccess = LocationObj.some(id =>
  [30, 32, 82, 51, 44, 26, 16, 24].includes(id),
);

function DashboardV2() {
  const [open, setOpen] = useState(false); // Drawer visibility state
  const [drawerType, setDrawerType] = useState(''); // Store which type of content to show in the drawer
  const [collapsed, setCollapsed] = useState(true); // Sidebar collapsed state
  const [isSurveyPending, setIsSurveyPending] = useState(false);

  const navigate = useNavigate(); // Get the navigate function
  const location = useLocation(); // Get the current location (URL)
  const [document, setDocument] = useState('');
  const [reviewData, setReviewData] = React.useState({});
  const [loading, setLoading] = useState(true);

  const [type, setType] = useState('');
  const [productName, setProductName] = useState(null);
  const [surveyData, setSurveyData] = useState([]);
  const [company_id, setCompany_id] = useState(
    UserObj ? UserObj.company_id : null,
  );
  const [isModalOpenSurvey, setIsModalOpenSurvey] = useState(false);
  const [activeSurveyIndex, setActiveSurveyIndex] = useState(null);
  const [spinner, setSpinner] = useState(false);
  const [userServiceAccess, setUserServiceAccess] = useState(null);
  const [serviceReq, setServiceReq] = useState('');
  const [store, setStore] = useState('');
  const [completeData, setCompleteData] = useState([{}]);

  const [showMealPlan, setShowMealPlan] = useState(false);
  const mealPlanRef = useRef(null);

  const [showAditionalParking, setShowAditionalParking] = useState(false);
  const additionalParkingRef = useRef(null);

  const [showDayCare, setShowDayCare] = useState(false);
  const dayCareRef = useRef(null);

  const [showCatering, setShowCatering] = useState(false);
  const cateringRef = useRef(null);

  const [showExtendedWorkHrs, setShowExtendedWorkHrs] = useState(false);
  const extendedWorkHrsRef = useRef();

  const [showManpower, setShowManpower] = useState(false);
  const manpowerRef = useRef();

  const [showHolidayWork, setShowHolidayWork] = useState(false);
  const holidayWorkRef = useRef();

  const [showPrinterAccess, setShowPrinterAccess] = useState(false);
  const printerAccessRef = useRef();

  const [showParamedics, setShowParamedics] = useState(false);
  const paramedicsRef = useRef(null);

  const [showGym, setShowGym] = useState(false);
  const gymRef = useRef(null);

  const [dailyShuttle, setShowDailyShuttle] = useState(false);
  const dailyShuttleRef = useRef(null);

  const [showCourier, setShowCourier] = useState(false);
  const courierRef = useRef(null);

  const [showPantry, setShowPantry] = useState(false);
  const pantryRef = useRef(null);
  const [showInternet, setShowInternet] = useState(false);
  const internetRef = useRef(null);
  const [showRental, setShowRental] = useState(false);
  const rentalRef = useRef(null);

  const [showRoomBooking, setShowRoomBooking] = useState(false);

  var currentDay = moment().format('DD');

  const handleCompleteData = data => {
    setCompleteData(data);
  };

  // Sidebar Toggle
  const toggleCollapsed = () => {
    setCollapsed(prevState => !prevState);
  };

  // Open drawer with the specific type (content)
  const showDrawer = type => {
    setDrawerType(type); // Set content type based on the clicked menu item
    setOpen(true);
    navigate('/Dashboard');
  };

  // Close the drawer
  const onClose = () => {
    setOpen(false);
    setDrawerType('');
    navigate('/Dashboard'); // Reset the drawer type
  };

  // Define content for the drawer based on the type
  const getDrawerContent = () => {
    switch (drawerType) {
      case 'desk-booking':
        return <p>Desk Booking Content</p>;
      case 'meeting-room':
        return <p>Meeting Room Content</p>;
      case 'skywatch':
        return <p>SkyWatch Content</p>;
      case 'access-control':
        return <p>Access Control Content</p>;
      case 'attendance':
        return <p>Attendance Content</p>;
      case 'visitor-management':
        return <p>Visitor Management Content</p>;
      case 'rewardkart':
        return <p>RewardKart Content</p>;
      case 'tata-tele':
        return <p>TATA TeleServices Content</p>;
      default:
        return <p>Select an item to view content.</p>;
    }
  };

  // Handle logout
  // const handleLogout = () => {
  //   KeycloakManager.logout(); // Call KeycloakManager's logout function
  // };

  // On page load (or route change), check for the drawerType in the URL
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const drawerTypeFromURL = queryParams.get('drawerType');

    if (drawerTypeFromURL) {
      showDrawer(drawerTypeFromURL); // Open the drawer with the type from URL
    }
  }, [location]); // Trigger when the location changes (route changes)

  const [open1, setOpen1] = useState(false);
  const showDrawer1 = () => {
    setOpen1(true);
  };

  const onClose1 = () => {
    setOpen1(false);
  };

  var SwCarouselSetting = {
    dots: true,
    infinite: true,
    speed: 500,
    lazyLoad: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    // nextArrow: <CustomNextArrow />,
    // prevArrow: <CustomPrevArrow />
  };

  const getDocumentsCount = async () => {
    let authToken = JSON.parse(localStorage.getItem('headData'));
    const userObj = JSON.parse(localStorage.getItem('headData')); // Assuming this is how you access UserObj.

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_PROD_URL}getData/getDocDetails?companyId=${
          userObj?.company_id
        }`,
        {
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        },
      );

      if (response.data.status === 200) {
        setDocument(response.data.data); // Set the document data if response is successful
      } else {
        toast.error('No data found', {});
      }
    } catch (error) {
      console.error('Error fetching documents:', error);
      toast.error('An error occurred while fetching data', {});
    }
  };

  // UseEffect to call getDocumentsCount when the component mounts
  useEffect(() => {
    getDocumentsCount();
  }, []); // Empty dependency array means this runs only once after initial render

  const onReviewClick = () => {
    let path = `LegalAndCompliance`;
    navigate(path);
  };

  // const headDate = JSON.parse(localStorage.getItem('headData'))
  // if (headDate.loginVersion !== 'v26') {
  //   localStorage.removeItem('token');

  //   localStorage.removeItem('amsToken');

  //   localStorage.removeItem('headData');

  //   localStorage.removeItem('setCloudKitchModal');

  //   localStorage.removeItem('roomNames');

  //   localStorage.setItem('bannerStatus', false)

  //   window.location.href = '/';

  //   sessionStorage.clear();
  // }

  useEffect(() => {
    const pendingRequestUserList = async () => {
      const UserObj = JSON.parse(localStorage.getItem('headData')); // Assuming UserObj is stored in localStorage or comes from a global state
      const getCompanyId = UserObj ? UserObj.company_id : null;
      const recId = UserObj ? UserObj.rec_id : null;
      let authToken = JSON.parse(localStorage.getItem('headData'));

      try {
        // Call locationUser API
        await locationUser({
          params: { spoc: recId, client: getCompanyId },
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        });

        // Call get-pending-req-userlist API
        const params = {
          company_id: UserObj?.company_id,
          userid: UserObj?.rec_id,
          location: JSON.parse(localStorage.getItem('locationData')),
        };

        const resOp = await axios.post(
          `${process.env.REACT_APP_API_URL}userReview/get-pending-req-userlist`,
          params,
          {
            headers: {
              Authorization: authToken?.spintlyToken,
            },
          },
        );

        if (resOp.data.status === 'success') {
          setReviewData(resOp.data.data);
        }
      } catch (error) {
        console.error('Error fetching pending request user list:', error);
      } finally {
        setLoading(false);
      }
    };

    pendingRequestUserList();
  }, []); // Empty dependency array ensures this runs only once on component mount

  const handleClick = newType => {
    setType(newType);
    clickBottomEvent(newType);
  };

  // mix-panel on icon click
  function clickBottomEvent(newType) {
    if (newType == 'meetingRoom') {
      if (UserObj) {
        mixpanel.track('Meeting Room Scheduler', {
          PageName: 'Dashboard',
          UserEmail: UserObj.email,
          UserName: UserObj.fname + ' ' + UserObj.lname,
          UserId: UserObj.rec_id,
          CompanyId: UserObj.company_id,
          CompanyName: UserObj.company_name,
          Type: 'Survey',
        });
      }
    } else if (newType == 'hotDesking') {
      if (UserObj) {
        mixpanel.track('Hot Desking (Flexi Desk)', {
          PageName: 'Dashboard',
          UserEmail: UserObj.email,
          UserName: UserObj.fname + ' ' + UserObj.lname,
          UserId: UserObj.rec_id,
          CompanyId: UserObj.company_id,
          CompanyName: UserObj.company_name,
          Type: 'Survey',
        });
      }
    } else if (newType == 'visitormanagesys') {
      if (UserObj) {
        mixpanel.track('Visitor Management System', {
          PageName: 'Dashboard',
          UserEmail: UserObj.email,
          UserName: UserObj.fname + ' ' + UserObj.lname,
          UserId: UserObj.rec_id,
          CompanyId: UserObj.company_id,
          CompanyName: UserObj.company_name,
          Type: 'Survey',
        });
      }
    } else if (newType == 'attendancemanage') {
      if (UserObj) {
        mixpanel.track('Attendance Management App', {
          PageName: 'Dashboard',
          UserEmail: UserObj.email,
          UserName: UserObj.fname + ' ' + UserObj.lname,
          UserId: UserObj.rec_id,
          CompanyId: UserObj.company_id,
          CompanyName: UserObj.company_name,
          Type: 'Survey',
        });
      }
    } else if (newType == 'smartworks') {
      if (UserObj) {
        mixpanel.track('Smartworks Super App', {
          PageName: 'Dashboard',
          UserEmail: UserObj.email,
          UserName: UserObj.fname + ' ' + UserObj.lname,
          UserId: UserObj.rec_id,
          CompanyId: UserObj.company_id,
          CompanyName: UserObj.company_name,
          Type: 'Survey',
        });
      }
    } else if (newType == 'feedback') {
      if (UserObj) {
        mixpanel.track('Smart Feedback', {
          PageName: 'Dashboard',
          UserEmail: UserObj.email,
          UserName: UserObj.fname + ' ' + UserObj.lname,
          UserId: UserObj.rec_id,
          CompanyId: UserObj.company_id,
          CompanyName: UserObj.company_name,
          Type: 'Survey',
        });
      }
    } else if (newType == 'pantry') {
      if (UserObj) {
        mixpanel.track('Pantry Management', {
          PageName: 'Dashboard',
          UserEmail: UserObj.email,
          UserName: UserObj.fname + ' ' + UserObj.lname,
          UserId: UserObj.rec_id,
          CompanyId: UserObj.company_id,
          CompanyName: UserObj.company_name,
          Type: 'Survey',
        });
      }
    }
  }

  // const clickBottomEvent = (type) => {
  //   if (UserObj) {
  //     let eventType;
  //     switch (type) {
  //       case 'meetingRoom':
  //         eventType = 'Meeting Room Scheduler';
  //         break;
  //       case 'hotDesking':
  //         eventType = 'Hot Desking (Flexi Desk)';
  //         break;
  //       case 'visitormanagesys':
  //         eventType = 'Visitor Management System';
  //         break;
  //       case 'attendancemanage':
  //         eventType = 'Attendance Management App';
  //         break;
  //       case 'smartworks':
  //         eventType = 'Smartworks Super App';
  //         break;
  //       case 'feedback':
  //         eventType = 'Smart Feedback';
  //         break;
  //       case 'pantry':
  //         eventType = 'Pantry Management';
  //         break;
  //       default:
  //         return; // If no valid type, exit early
  //     }

  //     // Mixpanel tracking logic
  //     mixpanel.track(eventType, {
  //       PageName: 'Dashboard',
  //       UserEmail: UserObj.email,
  //       UserName: `${UserObj.fname} ${UserObj.lname}`,
  //       UserId: UserObj.rec_id,
  //       CompanyId: UserObj.company_id,
  //       CompanyName: UserObj.company_name,
  //       Type: 'Survey',
  //     });

  //   }
  // };

  const sendProductEnquiryMail = name => {
    let authToken = JSON.parse(localStorage.getItem('headData'));
    const locationWithShortName = allLocationWithShortName();
    // this.setState({ productName: name });
    setProductName(name);
    let param = {
      product_name: name,
      company_name: UserObj.company_name,
      email: UserObj.email,
      fname: UserObj.fname,
      lname: UserObj.lname,
      phone: UserObj.phone,
      location_name: getLocationNameById(
        JSON.parse(locationWithShortName),
        UserObj.location_id,
      ),
      location_id: UserObj.loc_rec_id,
    };

    axios
      .post(
        `${process.env.REACT_APP_API_URL}basic-data/new-product-enquiry`,
        param,
        {
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        },
      )
      .then(res => {
        if (res.status == 200) {
          toast.success(res.data.message, {});
        }
      })
      .catch(err => {
        toast.error('Unable to submit Product enquiry', {});
        console.log('email err', err);
      });
    if (UserObj) {
      mixpanel.track('Inquiry', {
        PageName: 'Dashboard',
        UserEmail: UserObj.email,
        UserName: UserObj.fname + ' ' + UserObj.lname,
        UserId: UserObj.rec_id,
        CompanyId: UserObj.company_id,
        CompanyName: UserObj.company_name,
        Type: 'Survey',
      });
    }
  };

  // for survey Part

  const getSurvey = async () => {
    const userid = UserObj?.rec_id;
    const authToken = JSON.parse(localStorage.getItem('headData'));

    try {
      const res = await axios.get(
        `${
          process.env.REACT_APP_API_URL
        }survey/getSurveyByCompany/${company_id}/${userid}`,
        {
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        },
      );

      if (res.data.statusValue === 200) {
        const surveyArray = res.data.data;
        setSurveyData(surveyArray);

        // Show modal only if array has data (i.e., survey not filled)
        if (surveyArray.length > 0) {
          handleSurveyModal(); // trigger modal logic
        }
      }
    } catch (error) {
      console.error('Error fetching survey data:', error);
    }
  };

  // to open Model in survey

  const openModalSurveyData = () => {
    const visitedBefore = localStorage.getItem('visitedBeforeSurveyQ1FY26');

    if (!visitedBefore) {
      // If user hasn't visited before, set the flag and schedule the modal to open after 3 seconds
      const timer = setTimeout(() => {
        // this.setState({ isModalOpenSurvey: true });
        setIsModalOpenSurvey(true);
        localStorage.setItem('visitedBeforeSurveyQ1FY26', Date.now()); // Set the current timestamp
      }, 3000);

      // Clear the timer if the component unmounts before 3 seconds
      return () => clearTimeout(timer);
    }
  };

  const openModalSurvey = () => {
    setIsModalOpenSurvey(true);
  };

  const closeModalSurvey = () => {
    setIsModalOpenSurvey(false);
  };

  const getAllUserAccess = () => {
    const localDaata = JSON.parse(localStorage.getItem('headData'));
    let authToken = JSON.parse(localStorage.getItem('headData'));
    if (!localDaata) {
      return;
    }
    let param = {
      user_id: localDaata.rec_id,
      client_id: localDaata.company_id,
    };
    axios
      .post(
        process.env.REACT_APP_API_URL + 'userRoles/get-user-role-access',
        param,
        {
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        },
      )
      .then(response => {
        if ((response.data.status = 'success')) {
          // this.setState({ userServiceAccess: response.data.data.userRoleData });
          setUserServiceAccess(response?.data?.data?.userRoleData);
          if (!ManageApproval || !ManageAncillary) {
            ManageApproval =
              response.data.data.userRoleData &&
              response.data.data.userRoleData?.find(
                element => element.service_id == '23',
              );
            ManageAncillary =
              response.data.data.userRoleData &&
              response.data.data.userRoleData?.find(
                element => element.service_id == '27',
              );
          }
        }
      });
  };

  const handleSurveyModal = () => {
    const isLoggedIn = !!localStorage.getItem('headData');
    const visitedBefore = localStorage.getItem('visitedBeforeSurveyQ1FY26');
    const lastVisitTime = visitedBefore ? parseInt(visitedBefore, 10) : null;
    const now = Date.now();
    const TWENTY_FOUR_HOURS = 24 * 60 * 60 * 1000;
    const hash = window.location.hash;

    const shouldShowModal =
      !lastVisitTime || now - lastVisitTime > TWENTY_FOUR_HOURS;

    if (isLoggedIn) {
      if (hash === '#feedback') {
        setIsModalOpenSurvey(true);
        localStorage.setItem('visitedBeforeSurveyQ1FY26', Date.now());
      } else if (shouldShowModal) {
        const timer = setTimeout(() => {
          setIsModalOpenSurvey(true);
          localStorage.setItem('visitedBeforeSurveyQ1FY26', Date.now());
        }, 3000);
        return () => clearTimeout(timer);
      }
    }
  };

  useEffect(() => {
    getSurvey();
    getAllUserAccess();
    btnClick();
  }, []);
  // For Notice Board Start Review
  const handleClick1 = () => {
    localStorage.setItem('reviewdLocIds', [reviewData.reviewedLocIds]);
    if (localStorage.getItem('exitReview') == 'false') {
      navigate({
        pathname: '/ActiveMember',
      });
    } else {
      navigate({
        pathname: '/monthlyReview',
        // reviewdLocIds: this.state.reviewData.reviewedLocIds
      });
    }
    if (UserObj) {
      mixpanel.track('Monthly Review', {
        PageName: 'Dashboard',
        UserEmail: UserObj.email,
        UserName: UserObj.fname + ' ' + UserObj.lname,
        UserId: UserObj.rec_id,
        CompanyId: UserObj.company_id,
        CompanyName: UserObj.company_name,
        Type: 'Notice Board',
      });
    }
  };

  function clickServiceRequest(service) {
    if (service == 'parking') {
      if (UserObj) {
        mixpanel.track('Parking Slots Request', {
          PageName: 'Dashboard',
          UserEmail: UserObj.email,
          UserName: UserObj.fname + ' ' + UserObj.lname,
          UserId: UserObj.rec_id,
          CompanyId: UserObj.company_id,
          CompanyName: UserObj.company_name,
          Type: 'Service Request',
        });
      }
    } else if (service == 'room booking') {
      if (UserObj) {
        mixpanel.track('Room Booking Request', {
          PageName: 'Dashboard',
          UserEmail: UserObj.email,
          UserName: UserObj.fname + ' ' + UserObj.lname,
          UserId: UserObj.rec_id,
          CompanyId: UserObj.company_id,
          CompanyName: UserObj.company_name,
          Type: 'Service Request',
        });
      }
    } else if (service == 'space') {
      if (UserObj) {
        mixpanel.track('Space Requirement Request', {
          PageName: 'Dashboard',
          UserEmail: UserObj.email,
          UserName: UserObj.fname + ' ' + UserObj.lname,
          UserId: UserObj.rec_id,
          CompanyId: UserObj.company_id,
          CompanyName: UserObj.company_name,
          Type: 'Service Request',
        });
      }
    } else if (service == 'printer') {
      if (UserObj) {
        mixpanel.track('Printer and Scanner Request', {
          PageName: 'Dashboard',
          UserEmail: UserObj.email,
          UserName: UserObj.fname + ' ' + UserObj.lname,
          UserId: UserObj.rec_id,
          CompanyId: UserObj.company_id,
          CompanyName: UserObj.company_name,
          Type: 'Service Request',
        });
      }
    } else if (service == 'manpower') {
      if (UserObj) {
        mixpanel.track('Manpower Request', {
          PageName: 'Dashboard',
          UserEmail: UserObj.email,
          UserName: UserObj.fname + ' ' + UserObj.lname,
          UserId: UserObj.rec_id,
          CompanyId: UserObj.company_id,
          CompanyName: UserObj.company_name,
          Type: 'Service Request',
        });
      }
    } else if (service == 'food') {
      if (UserObj) {
        mixpanel.track('Food Request', {
          PageName: 'Dashboard',
          UserEmail: UserObj.email,
          UserName: UserObj.fname + ' ' + UserObj.lname,
          UserId: UserObj.rec_id,
          CompanyId: UserObj.company_id,
          CompanyName: UserObj.company_name,
          Type: 'Service Request',
        });
      }
    } else if (service == 'holiday') {
      if (UserObj) {
        mixpanel.track('Public Holiday Working Request', {
          PageName: 'Dashboard',
          UserEmail: UserObj.email,
          UserName: UserObj.fname + ' ' + UserObj.lname,
          UserId: UserObj.rec_id,
          CompanyId: UserObj.company_id,
          CompanyName: UserObj.company_name,
          Type: 'Service Request',
        });
      }
    } else if (service == 'workHrs') {
      if (UserObj) {
        mixpanel.track('Extended Working Hours Request', {
          PageName: 'Dashboard',
          UserEmail: UserObj.email,
          UserName: UserObj.fname + ' ' + UserObj.lname,
          UserId: UserObj.rec_id,
          CompanyId: UserObj.company_id,
          CompanyName: UserObj.company_name,
          Type: 'Service Request',
        });
      }
    } else if (service == 'courier') {
      if (UserObj) {
        mixpanel.track('Courier Request', {
          PageName: 'Dashboard',
          UserEmail: UserObj.email,
          UserName: UserObj.fname + ' ' + UserObj.lname,
          UserId: UserObj.rec_id,
          CompanyId: UserObj.company_id,
          CompanyName: UserObj.company_name,
          Type: 'Service Request',
        });
      }
    } else if (service == 'internet') {
      if (UserObj) {
        mixpanel.track('Internet Services Request', {
          PageName: 'Dashboard',
          UserEmail: UserObj.email,
          UserName: UserObj.fname + ' ' + UserObj.lname,
          UserId: UserObj.rec_id,
          CompanyId: UserObj.company_id,
          CompanyName: UserObj.company_name,
          Type: 'Service Request',
        });
      }
    } else if (service == 'others') {
      if (UserObj) {
        mixpanel.track('Others Request', {
          PageName: 'Dashboard',
          UserEmail: UserObj.email,
          UserName: UserObj.fname + ' ' + UserObj.lname,
          UserId: UserObj.rec_id,
          CompanyId: UserObj.company_id,
          CompanyName: UserObj.company_name,
          Type: 'Service Request',
        });
      }
    } else if (service == 'it_rental') {
      if (UserObj) {
        mixpanel.track('IT Rental', {
          PageName: 'Dashboard',
          UserEmail: UserObj.email,
          UserName: UserObj.fname + ' ' + UserObj.lname,
          UserId: UserObj.rec_id,
          CompanyId: UserObj.company_id,
          CompanyName: UserObj.company_name,
          Type: 'Service Request',
        });
      }
    }
  }

  function handleClick3(service) {
    setServiceReq(service);
    clickServiceRequest(service);
  }
  // to apply mix-panel on android & apple app icon

  useEffect(() => {
    if (store) {
      // This effect will run when the `store` state changes
      if (store === 'android') {
        if (UserObj) {
          mixpanel.track('Android App Request', {
            PageName: 'Dashboard',
            UserEmail: UserObj.email,
            UserName: `${UserObj.fname} ${UserObj.lname}`,
            UserId: UserObj.rec_id,
            CompanyId: UserObj.company_id,
            CompanyName: UserObj.company_name,
            Type: 'App Request',
          });
        }
      } else if (store === 'apple') {
        if (UserObj) {
          mixpanel.track('Apple App Request', {
            PageName: 'Dashboard',
            UserEmail: UserObj.email,
            UserName: `${UserObj.fname} ${UserObj.lname}`,
            UserId: UserObj.rec_id,
            CompanyId: UserObj.company_id,
            CompanyName: UserObj.company_name,
            Type: 'App Request',
          });
        }
      }
    }
  }, [store, UserObj]);

  // mix-panel when on Dashboard Page
  function btnClick() {
    if (UserObj) {
      mixpanel.track('Dashboard Page View', {
        PageName: 'Dashboard',
        UserEmail: UserObj.email,
        UserName: UserObj.fname + ' ' + UserObj.lname,
        UserId: UserObj.rec_id,
        CompanyId: UserObj.company_id,
        CompanyName: UserObj.company_name,
        Type: 'Dashboard',
      });
    }
  }

  const NoticeSliderSetting = {
    autoplay: true,
    infinite: Slider.length > 1,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
  };

  // Drawer Exmaple
  const [showDrawerExample, setShowDrawerExample] = useState(false);
  // Date Exmaple in drawer
  const [singleDate, setSingleDate] = useState(null);

  const handleClose = (isSuccess = false, successMessage = '') => {
    // 1️⃣ close OffCanvas
    setShowParamedics(false);
    setShowGym(false);
    setShowDailyShuttle(false);
    setShowCourier(false);

    setShowPantry(false);
    setShowInternet(false);
    setShowRental(false);
    setShowRoomBooking(false);

    // 2️⃣ show toast AFTER OffCanvas animation
    if (isSuccess && successMessage) {
      setTimeout(() => {
        toast.success(successMessage, {
          autoClose: 3000,
        });
      }, 300); // ✅ small delay
    }
  };

  return (
    <>
      <Layout>
        <Sidebar collapsed={collapsed} showDrawer={showDrawer} />
        <CustomHeader collapsed={collapsed} toggleCollapsed={toggleCollapsed} />

        <Layout
          className={
            collapsed ? 'PageLayout CollapsedPageLayout' : 'PageLayout'
          }
        >
          {/* Content */}
          {/* <div className="PageContent">
            <h1>Dashboard</h1>
            <Button onClick={handleLogOut}>LogOut</Button>
           
          </div> */}
          <div className="PageContent p-0 m-0">
            {UserObj?.company_id != process.env.REACT_APP_PROZO_COM_ID &&
            UserObj?.company_id != process.env.REACT_APP_ASL_COM_ID ? (
              <div className="row flex-column-reverse flex-md-row">
                <div className=" col-lg-7">
                  <div className="Dashboard_service_container ">
                    <div className="SwHeading">
                      <h2>Boost employees' work life</h2>
                    </div>

                    {/* Put all drawers at the bottom of the page */}

                    <div
                      className={
                        ManageAncillary &&
                        ManageAncillary.role_for_read == '1' &&
                        ManageAncillary.role_for_write != '1'
                          ? 'disabled-link'
                          : ''
                      }
                    >
                      <div className="disabled-linkcursor">
                        <div className="row">
                          {/* Meal Plan Request */}
                          <div className="col-4 col-md-4 col-lg-3 px-2">
                            <a
                              className="DashboardServiceBox"
                              onClick={() => {
                                handleClick3('meal');
                                setShowMealPlan(true);
                              }}
                            >
                              <div className="DSB_Icon">
                                <img
                                  src="https://smartworks-production.s3.ap-southeast-1.amazonaws.com/assets/new-dashboard-latest/meal.png"
                                  loading="lazy"
                                  alt="Meal"
                                />
                              </div>
                              <div className="DSB_Title">Meal Plan</div>
                            </a>
                          </div>
                          {/* SwOffCanvas  Meal Plan Request */}
                          <SwOffCanvas
                            show={showMealPlan}
                            onClose={() => setShowMealPlan(false)}
                            title="Meal Plan Request"
                            placement="end"
                            backdrop="static"
                            keyboard={false}
                            footer={
                              <div className="OffCanvasFooter_Btns">
                                <SwButton
                                  variant="dark-outline"
                                  onClick={() => {
                                    mealPlanRef.current?.resetValue();
                                    setShowMealPlan(true);
                                  }}
                                >
                                  Reset
                                </SwButton>

                                {!mealPlanRef.current?.state?.btnStatus ? (
                                  <SwButton
                                    variant="primary"
                                    onClick={e =>
                                      mealPlanRef.current?.handleSubmit(e)
                                    }
                                  >
                                    Submit
                                  </SwButton>
                                ) : (
                                  <SwButton
                                    variant="dark"
                                    disabled
                                    icon={<i class="bi bi-arrow-repeat" />}
                                  >
                                    Processing
                                  </SwButton>
                                )}
                              </div>
                            }
                          >
                            <MealPlanServiceRequest
                              ref={mealPlanRef}
                              onClose={() => setShowMealPlan(false)}
                            />
                          </SwOffCanvas>

                          {/* Additional Parking Slots */}
                          <div className="col-4 col-md-4 col-lg-3 px-2 ">
                            <a
                              className="DashboardServiceBox"
                              role="button"
                              onClick={() => {
                                handleClick3('parking');
                                setShowAditionalParking(true);
                              }}
                            >
                              <div className="DSB_Icon">
                                <img
                                  src="https://smartworks-production.s3.ap-southeast-1.amazonaws.com/assets/new-dashboard-latest/carparking.png"
                                  loading="lazy"
                                />
                              </div>
                              <div className="DSB_Title">
                                Additional Parking Slots
                              </div>
                            </a>
                          </div>
                          {/* SwOffCanvas Additional Parking Requests */}
                          <SwOffCanvas
                            show={showAditionalParking}
                            onClose={() => setShowAditionalParking(false)}
                            title="Additional Parking Requests"
                            placement="end"
                            backdrop="static"
                            keyboard={false}
                            footer={
                              <div className="OffCanvasFooter_Btns">
                                <SwButton
                                  variant="dark-outline"
                                  onClick={() => {
                                    additionalParkingRef.current?.resetValue();
                                    setShowAditionalParking(true);
                                  }}
                                >
                                  Reset
                                </SwButton>

                                {!additionalParkingRef.current?.state
                                  ?.btnStatus ? (
                                  <SwButton
                                    variant="primary"
                                    onClick={e =>
                                      additionalParkingRef.current?.handleSubmit(
                                        e,
                                      )
                                    }
                                  >
                                    Submit
                                  </SwButton>
                                ) : (
                                  <SwButton
                                    variant="dark"
                                    disabled
                                    icon={<i class="bi bi-arrow-repeat" />}
                                  >
                                    Processing
                                  </SwButton>
                                )}
                              </div>
                            }
                          >
                            <ParkingSlots
                              ref={additionalParkingRef}
                              onClose={() => setShowAditionalParking(false)}
                            />
                          </SwOffCanvas>

                          <></>
                          {crecheCareLocationAccess ? (
                            <>
                              {/* Creche and Day Care */}
                              <div className="col-4 col-md-4 col-lg-3 px-2">
                                <a
                                  className="DashboardServiceBox"
                                  role="button"
                                  onClick={() => {
                                    handleClick3('crache and day care');
                                    setShowDayCare(true);
                                  }}
                                >
                                  <div className="DSB_Icon">
                                    <img
                                      src="https://d2jovvsod2x1gg.cloudfront.net/csp-files/daycare.svg"
                                      loading="lazy"
                                    />
                                  </div>
                                  <div className="DSB_Title">
                                    Creche and Day Care
                                  </div>
                                </a>
                              </div>
                              {/* SwOffCanvas Creche and Day Care Request */}
                              <SwOffCanvas
                                show={showDayCare}
                                onClose={() => setShowDayCare(false)}
                                title="Creche and Day Care Request"
                                placement="end"
                                backdrop="static"
                                keyboard={false}
                                footer={
                                  <div className="OffCanvasFooter_Btns">
                                    <SwButton
                                      variant="dark-outline"
                                      onClick={() => {
                                        dayCareRef.current?.resetValue();
                                        setShowDayCare(true);
                                      }}
                                    >
                                      Reset
                                    </SwButton>

                                    {!dayCareRef.current?.state?.btnStatus ? (
                                      <SwButton
                                        variant="primary"
                                        onClick={e =>
                                          dayCareRef.current?.onFormSubmit1(e)
                                        }
                                      >
                                        Submit
                                      </SwButton>
                                    ) : (
                                      <SwButton
                                        variant="dark"
                                        disabled
                                        icon={<i class="bi bi-arrow-repeat" />}
                                      >
                                        Processing
                                      </SwButton>
                                    )}
                                  </div>
                                }
                              >
                                <CracheCareServiceRequest
                                  ref={dayCareRef}
                                  onClose={() => setShowDayCare(false)}
                                />
                              </SwOffCanvas>
                            </>
                          ) : (
                            ''
                          )}

                          {/* Catering and Decoration Request */}
                          <div className="col-4 col-md-4 col-lg-3 px-2">
                            <a
                              className="DashboardServiceBox"
                              onClick={() => {
                                handleClick3('space');
                                setShowCatering(true);
                              }}
                            >
                              <div className="DSB_Icon">
                                <img
                                  src="https://ticketing-uat.s3.ap-south-1.amazonaws.com/attachment/bd73fbd36ec0febb1723456630010.svg"
                                  loading="lazy"
                                />
                              </div>
                              <div className="DSB_Title">
                                Catering and Decoration
                              </div>
                            </a>
                          </div>

                          {/* SwOffCanvas Catering and Decoration Request */}
                          <SwOffCanvas
                            show={showCatering}
                            onClose={() => setShowCatering(false)}
                            title="Catering and Decoration Request"
                            placement="end"
                            backdrop="static"
                            keyboard={false}
                            footer={
                              <div className="OffCanvasFooter_Btns">
                                <SwButton
                                  variant="dark-outline"
                                  onClick={() =>
                                    cateringRef.current?.resetValue()
                                  }
                                >
                                  Reset
                                </SwButton>

                                {!cateringRef.current?.state?.btnStatus ? (
                                  <SwButton
                                    variant="primary"
                                    onClick={e =>
                                      cateringRef.current?.handleSubmit(e)
                                    }
                                  >
                                    Submit
                                  </SwButton>
                                ) : (
                                  <SwButton
                                    variant="dark"
                                    disabled
                                    icon={<i class="bi bi-arrow-repeat" />}
                                  >
                                    Processing
                                  </SwButton>
                                )}
                              </div>
                            }
                          >
                            <SpaceRequire
                              ref={cateringRef}
                              onClose={() => setShowCatering(false)}
                            />
                          </SwOffCanvas>

                          {/* Paramedics Request */}
                          {paramedicsLocationAccess ? (
                            <div className="col-4 col-md-4 col-lg-3 px-2">
                              <a
                                className="DashboardServiceBox"
                                role="button"
                                onClick={() => setShowParamedics(true)}
                              >
                                <div className="DSB_Icon">
                                  <img
                                    src="https://d2jovvsod2x1gg.cloudfront.net/csp-files/paramedics.svg"
                                    loading="lazy"
                                  />
                                </div>
                                <div className="DSB_Title">Paramedics</div>
                              </a>
                            </div>
                          ) : (
                            ''
                          )}

                          <SwOffCanvas
                            show={showParamedics}
                            onClose={handleClose} // ✅ USE THIS
                            title="Paramedics Request"
                            placement="end"
                            backdrop="static"
                            keyboard={false}
                            footer={
                              <div className="OffCanvasFooter_Btns">
                                <SwButton
                                  variant="dark-outline"
                                  onClick={() =>
                                    paramedicsRef.current?.resetValue()
                                  }
                                >
                                  Reset
                                </SwButton>

                                {!paramedicsRef.current?.state?.btnStatus ? (
                                  <SwButton
                                    variant="primary"
                                    onClick={e =>
                                      paramedicsRef.current?.handleSubmit(e)
                                    }
                                  >
                                    Submit
                                  </SwButton>
                                ) : (
                                  <SwButton
                                    variant="dark"
                                    disabled
                                    icon={<i class="bi bi-arrow-repeat" />}
                                  >
                                    Processing
                                  </SwButton>
                                )}
                              </div>
                            }
                          >
                            <ParamediceServiceRequest
                              ref={paramedicsRef}
                              onClose={handleClose}
                            />
                          </SwOffCanvas>

                          {/* Gym with Trainer Request */}
                          {gymWithTrainerLocationAccess ? (
                            <div className="col-4 col-md-4 col-lg-3 px-2">
                              <a
                                className="DashboardServiceBox"
                                role="button"
                                onClick={() => setShowGym(true)}
                              >
                                <div className="DSB_Icon">
                                  <img
                                    src="https://d2jovvsod2x1gg.cloudfront.net/csp-files/gym.svg"
                                    loading="lazy"
                                  />
                                </div>
                                <div className="DSB_Title">
                                  Gym with Trainer
                                </div>
                              </a>
                            </div>
                          ) : (
                            ''
                          )}

                          <SwOffCanvas
                            show={showGym}
                            onClose={handleClose} // ✅ USE THIS
                            title="Gym Request"
                            placement="end"
                            backdrop="static"
                            keyboard={false}
                            footer={
                              <div className="OffCanvasFooter_Btns">
                                <SwButton
                                  variant="dark-outline"
                                  onClick={() => gymRef.current?.resetValue()}
                                >
                                  Reset
                                </SwButton>

                                {!gymRef.current?.state?.btnStatus ? (
                                  <SwButton
                                    variant="primary"
                                    onClick={e =>
                                      gymRef.current?.handleSubmit(e)
                                    }
                                  >
                                    Submit
                                  </SwButton>
                                ) : (
                                  <SwButton
                                    variant="dark"
                                    disabled
                                    icon={<i class="bi bi-arrow-repeat" />}
                                  >
                                    Processing
                                  </SwButton>
                                )}
                              </div>
                            }
                          >
                            <GymTrainerServiceRequest
                              ref={gymRef}
                              onClose={handleClose}
                            />
                          </SwOffCanvas>

                          {/* Daily Shuttle Request */}
                          <div className="col-4 col-md-4 col-lg-3 px-2">
                            <a
                              className="DashboardServiceBox"
                              role="button"
                              onClick={() => setShowDailyShuttle(true)}
                            >
                              <div className="DSB_Icon">
                                <img
                                  src="https://smartworks-production.s3.ap-southeast-1.amazonaws.com/assets/new-dashboard-latest-new/taxi.png"
                                  loading="lazy"
                                />
                              </div>
                              <div className="DSB_Title">Daily Shuttle</div>
                            </a>
                          </div>

                          <SwOffCanvas
                            show={dailyShuttle}
                            onClose={handleClose} // ✅ USE THIS
                            title="Daily Shuttle Request"
                            placement="end"
                            backdrop="static"
                            keyboard={false}
                            footer={
                              <div className="OffCanvasFooter_Btns">
                                <SwButton
                                  variant="dark-outline"
                                  onClick={() =>
                                    dailyShuttleRef.current?.resetValue()
                                  }
                                >
                                  Reset
                                </SwButton>

                                {!dailyShuttleRef.current?.state?.btnStatus ? (
                                  <SwButton
                                    variant="primary"
                                    onClick={e =>
                                      dailyShuttleRef.current?.handleSubmit(e)
                                    }
                                  >
                                    Submit
                                  </SwButton>
                                ) : (
                                  <SwButton
                                    variant="dark"
                                    disabled
                                    icon={<i class="bi bi-arrow-repeat" />}
                                  >
                                    Processing
                                  </SwButton>
                                )}
                              </div>
                            }
                          >
                            <DailyShuttleServiceRequest
                              ref={dailyShuttleRef}
                              onClose={handleClose}
                            />
                          </SwOffCanvas>

                          {/* Courier Request */}
                          <div className="col-4 col-md-4 col-lg-3 px-2">
                            <a
                              className="DashboardServiceBox"
                              role="button"
                              onClick={() => setShowCourier(true)}
                            >
                              <div className="DSB_Icon">
                                <img
                                  src="https://smartworks-production.s3.ap-southeast-1.amazonaws.com/assets/new-dashboard-latest-new/logic.png"
                                  loading="lazy"
                                />
                              </div>
                              <div className="DSB_Title">Courier</div>
                            </a>
                          </div>

                          <SwOffCanvas
                            show={showCourier}
                            onClose={handleClose} // ✅ USE THIS
                            title="Courier Services Request"
                            placement="end"
                            backdrop="static"
                            keyboard={false}
                            footer={
                              <div className="OffCanvasFooter_Btns">
                                <SwButton
                                  variant="dark-outline"
                                  onClick={() =>
                                    courierRef.current?.resetValue()
                                  }
                                >
                                  Reset
                                </SwButton>

                                {!courierRef.current?.state?.btnStatus ? (
                                  <SwButton
                                    variant="primary"
                                    onClick={e =>
                                      courierRef.current?.handleSubmit(e)
                                    }
                                  >
                                    Submit
                                  </SwButton>
                                ) : (
                                  <SwButton
                                    variant="dark"
                                    disabled
                                    icon={<i class="bi bi-arrow-repeat" />}
                                  >
                                    Processing
                                  </SwButton>
                                )}
                              </div>
                            }
                          >
                            <Courier ref={courierRef} onClose={handleClose} />
                          </SwOffCanvas>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="Dashboard_service_container ">
                      <div className="SwHeading">
                        <h2>Boost your workspace</h2>
                      </div>
                      <div className="disabled-linkcursor">
                        <div className="row">
                          {/* Pantry and Stationary Items Request */}
                          <div className="col-4 col-md-4 col-lg-3 px-2">
                            <a
                              className="DashboardServiceBox"
                              role="button"
                              onClick={() => setShowPantry(true)}
                            >
                              <div className="DSB_Icon">
                                <img
                                  src="https://ticketing-uat.s3.ap-south-1.amazonaws.com/attachment/3b7e2d4aee36dac71723456661674.svg"
                                  loading="lazy"
                                />
                              </div>
                              <div className="DSB_Title">
                                Pantry and Stationary Items
                              </div>
                            </a>
                          </div>

                          <SwOffCanvas
                            show={showPantry}
                            onClose={handleClose} // ✅ USE THIS
                            title="Pantry and Stationary Items Request"
                            placement="end"
                            backdrop="static"
                            keyboard={false}
                            footer={
                              <div className="OffCanvasFooter_Btns">
                                <SwButton
                                  variant="dark-outline"
                                  onClick={() =>
                                    pantryRef.current?.resetValue()
                                  }
                                >
                                  Reset
                                </SwButton>

                                {!pantryRef.current?.state?.btnStatus ? (
                                  <SwButton
                                    variant="primary"
                                    onClick={e =>
                                      pantryRef.current?.handleSubmit(e)
                                    }
                                  >
                                    Submit
                                  </SwButton>
                                ) : (
                                  <SwButton
                                    variant="dark"
                                    disabled
                                    icon={<i class="bi bi-arrow-repeat" />}
                                  >
                                    Processing
                                  </SwButton>
                                )}
                              </div>
                            }
                          >
                            <Other ref={pantryRef} onClose={handleClose} />
                          </SwOffCanvas>

                          {/* Internet Services Request */}
                          <div className="col-4 col-md-4 col-lg-3 px-2">
                            <a
                              className="DashboardServiceBox"
                              role="button"
                              onClick={() => setShowInternet(true)}
                            >
                              <div className="DSB_Icon">
                                <img
                                  src="https://smartworks-production.s3.amazonaws.com/assets/new-dashboard-latest/ee58bdcb9f646c961679392391967.png"
                                  loading="lazy"
                                />
                              </div>
                              <div className="DSB_Title">Internet Services</div>
                            </a>
                          </div>

                          <SwOffCanvas
                            show={showInternet}
                            onClose={handleClose} // ✅ USE THIS
                            title="Internet Services Request"
                            placement="end"
                            backdrop="static"
                            keyboard={false}
                            footer={
                              <div className="OffCanvasFooter_Btns">
                                <SwButton
                                  variant="dark-outline"
                                  onClick={() =>
                                    internetRef.current?.resetValue()
                                  }
                                >
                                  Reset
                                </SwButton>

                                {!internetRef.current?.state?.btnStatus ? (
                                  <SwButton
                                    variant="primary"
                                    onClick={e =>
                                      internetRef.current?.handleSubmit(e)
                                    }
                                  >
                                    Submit
                                  </SwButton>
                                ) : (
                                  <SwButton
                                    variant="dark"
                                    disabled
                                    icon={<i class="bi bi-arrow-repeat" />}
                                  >
                                    Processing
                                  </SwButton>
                                )}
                              </div>
                            }
                          >
                            <InternetService
                              ref={internetRef}
                              onClose={handleClose}
                            />
                          </SwOffCanvas>

                          {/* Equipment Rentals Request */}
                          <div className="col-4 col-md-4 col-lg-3 px-2">
                            <a
                              className="DashboardServiceBox"
                              role="button"
                              onClick={() => setShowRental(true)}
                            >
                              <div className="DSB_Icon">
                                <img
                                  src="https://smartworks-production.s3.amazonaws.com/assets/new-dashboard-latest-new/rental.png"
                                  loading="lazy"
                                />
                              </div>
                              <div className="DSB_Title">Equipment Rentals</div>
                            </a>
                          </div>

                          <SwOffCanvas
                            show={showRental}
                            onClose={handleClose} // ✅ USE THIS
                            title="Equipment Rentals"
                            placement="end"
                            backdrop="static"
                            keyboard={false}
                            footer={
                              <div className="OffCanvasFooter_Btns">
                                <SwButton
                                  variant="dark-outline"
                                  onClick={() =>
                                    rentalRef.current?.resetValue()
                                  }
                                >
                                  Reset
                                </SwButton>

                                {!rentalRef.current?.state?.btnStatus ? (
                                  <SwButton
                                    variant="primary"
                                    onClick={e =>
                                      rentalRef.current?.handleSubmit(e)
                                    }
                                  >
                                    Submit
                                  </SwButton>
                                ) : (
                                  <SwButton
                                    variant="dark"
                                    disabled
                                    icon={<i class="bi bi-arrow-repeat" />}
                                  >
                                    Processing
                                  </SwButton>
                                )}
                              </div>
                            }
                          >
                            <ItRental ref={rentalRef} onClose={handleClose} />
                          </SwOffCanvas>

                          {/* Room Booking Request */}
                          {/* <div className="col-4 col-md-4 col-lg-3 px-2 " >
                            <a className="DashboardServiceBox" role='button'
                              id="modalToggle2"
                              data-toggle="modal"
                              data-target="#myModal35"
                              onClick={() => handleClick3('room booking')}
                            >
                              <div className="DSB_Icon">
                                <img
                                  src="https://smartworks-production.s3.ap-southeast-1.amazonaws.com/assets/new-dashboard-latest/roomBooking.png"
                                  loading="lazy"
                                />
                              </div>
                              <div className="DSB_Title">Room Booking</div>
                            </a>
                          </div> */}

                          <div className="col-4 col-md-4 col-lg-3 px-2">
                            <a
                              className="DashboardServiceBox"
                              role="button"
                              onClick={() => setShowRoomBooking(true)}
                            >
                              <div className="DSB_Icon">
                                <img
                                  src="https://smartworks-production.s3.amazonaws.com/assets/new-dashboard-latest-new/rental.png"
                                  loading="lazy"
                                />
                              </div>
                              <div className="DSB_Title">
                                Create Room Booking
                              </div>
                            </a>
                          </div>

                          {/* Renders its own SwOffCanvas (title + Reset/Submit footer) */}
                          <CreateRoomBooking
                            show={showRoomBooking}
                            onClose={handleClose}
                          />

                          <div className="col-4 col-md-4 col-lg-3 px-2">
                            <a
                              className="DashboardServiceBox"
                              role="button"
                              onClick={() => {
                                handleClick3('workHrs');
                                setShowExtendedWorkHrs(true);
                              }}
                            >
                              <div className="DSB_Icon">
                                <img
                                  src="https://smartworks-production.s3.ap-southeast-1.amazonaws.com/assets/new-dashboard-latest/time.png"
                                  loading="lazy"
                                />
                              </div>
                              <div className="DSB_Title">
                                Extended work hours
                              </div>
                            </a>
                          </div>
                          <SwOffCanvas
                            show={showExtendedWorkHrs}
                            onClose={() => setShowExtendedWorkHrs(false)}
                            title="Extended Work Hours"
                            placement="end"
                            backdrop="static"
                            keyboard={false}
                            footer={
                              <div className="OffCanvasFooter_Btns">
                                <SwButton
                                  variant="dark-outline"
                                  onClick={() => {
                                    extendedWorkHrsRef.current?.resetValue();
                                    setShowExtendedWorkHrs(true);
                                  }}
                                >
                                  Reset
                                </SwButton>

                                {!extendedWorkHrsRef.current?.state
                                  ?.btnStatus ? (
                                  <SwButton
                                    variant="primary"
                                    onClick={e =>
                                      extendedWorkHrsRef.current?.handleSubmit(
                                        e,
                                      )
                                    }
                                  >
                                    Submit
                                  </SwButton>
                                ) : (
                                  <SwButton
                                    variant="dark"
                                    disabled
                                    icon={<i class="bi bi-arrow-repeat" />}
                                  >
                                    Processing
                                  </SwButton>
                                )}
                              </div>
                            }
                          >
                            <ExtendedWorking
                              ref={extendedWorkHrsRef}
                              onClose={() => setShowExtendedWorkHrs(false)}
                            />
                          </SwOffCanvas>

                          {/* Manpower Request */}
                          <div className="col-4 col-md-4 col-lg-3 px-2">
                            <a
                              className="DashboardServiceBox"
                              role="button"
                              onClick={() => {
                                handleClick3('manpower');
                                setShowManpower(true);
                              }}
                            >
                              <div className="DSB_Icon">
                                <img
                                  src="https://smartworks-production.s3.ap-southeast-1.amazonaws.com/assets/new-dashboard-latest/manpower.png"
                                  loading="lazy"
                                />
                              </div>
                              <div className="DSB_Title">Manpower Request</div>
                            </a>
                          </div>
                          <SwOffCanvas
                            show={showManpower}
                            onClose={() => setShowManpower(false)}
                            title="Manpower Request"
                            placement="end"
                            backdrop="static"
                            keyboard={false}
                            footer={
                              <div className="OffCanvasFooter_Btns">
                                <SwButton
                                  variant="dark-outline"
                                  onClick={() => {
                                    manpowerRef.current?.resetValue();
                                    setShowManpower(true);
                                  }}
                                >
                                  Reset
                                </SwButton>

                                {!manpowerRef.current?.state?.btnStatus ? (
                                  <SwButton
                                    variant="primary"
                                    onClick={e =>
                                      manpowerRef.current?.onFormSubmit1(e)
                                    }
                                  >
                                    Submit
                                  </SwButton>
                                ) : (
                                  <SwButton
                                    variant="dark"
                                    disabled
                                    icon={<i class="bi bi-arrow-repeat" />}
                                  >
                                    Processing
                                  </SwButton>
                                )}
                              </div>
                            }
                          >
                            <ManPowerRequest
                              ref={manpowerRef}
                              onClose={() => setShowManpower(false)}
                            />
                          </SwOffCanvas>

                          <div className="col-4 col-md-4 col-lg-3 px-2">
                            <a
                              className="DashboardServiceBox"
                              role="button"
                              onClick={() => {
                                handleClick3('holiday');
                                setShowHolidayWork(true);
                              }}
                            >
                              <div className="DSB_Icon">
                                <img
                                  src="https://smartworks-production.s3.ap-southeast-1.amazonaws.com/assets/new-dashboard-latest/work.png"
                                  loading="lazy"
                                />
                              </div>
                              <div className="DSB_Title">
                                Working on a public holiday
                              </div>
                            </a>
                          </div>

                          <SwOffCanvas
                            show={showHolidayWork}
                            onClose={() => setShowHolidayWork(false)}
                            title="Working on a Public Holiday"
                            placement="end"
                            backdrop="static"
                            keyboard={false}
                            footer={
                              <div className="OffCanvasFooter_Btns">
                                <SwButton
                                  variant="dark-outline"
                                  onClick={() => {
                                    holidayWorkRef.current?.resetValue();
                                    setShowHolidayWork(true);
                                  }}
                                >
                                  Reset
                                </SwButton>

                                {!holidayWorkRef.current?.state?.btnStatus ? (
                                  <SwButton
                                    variant="primary"
                                    onClick={e =>
                                      holidayWorkRef.current?.handleSubmit(e)
                                    }
                                  >
                                    Submit
                                  </SwButton>
                                ) : (
                                  <SwButton
                                    variant="dark"
                                    disabled
                                    icon={<i class="bi bi-arrow-repeat" />}
                                  >
                                    Processing
                                  </SwButton>
                                )}
                              </div>
                            }
                          >
                            <PublicWorking
                              ref={holidayWorkRef}
                              onClose={() => setShowHolidayWork(false)}
                            />
                          </SwOffCanvas>

                          {/* Printer and Scanner Access Request */}
                          <div className="col-4 col-md-4 col-lg-3 px-2">
                            <a
                              className="DashboardServiceBox"
                              role="button"
                              onClick={() => {
                                handleClick3('printer');
                                setShowPrinterAccess(true);
                              }}
                            >
                              <div className="DSB_Icon">
                                <img
                                  src="https://smartworks-production.s3.ap-southeast-1.amazonaws.com/assets/new-dashboard-latest-new/printer.png"
                                  loading="lazy"
                                />
                              </div>
                              <div className="DSB_Title">
                                Printer and Scanner Access
                              </div>
                            </a>
                          </div>

                          <SwOffCanvas
                            show={showPrinterAccess}
                            onClose={() => setShowPrinterAccess(false)}
                            title="Printer and Scanner Access"
                            placement="end"
                            backdrop="static"
                            keyboard={false}
                            footer={
                              <div className="OffCanvasFooter_Btns">
                                <SwButton
                                  variant="dark-outline"
                                  onClick={() => {
                                    printerAccessRef.current?.resetValue();
                                    setShowPrinterAccess(true);
                                  }}
                                >
                                  Reset
                                </SwButton>

                                {!printerAccessRef.current?.state?.btnStatus ? (
                                  <SwButton
                                    variant="primary"
                                    onClick={e =>
                                      printerAccessRef.current?.handleSubmit(e)
                                    }
                                  >
                                    Submit
                                  </SwButton>
                                ) : (
                                  <SwButton
                                    variant="dark"
                                    disabled
                                    icon={<i class="bi bi-arrow-repeat" />}
                                  >
                                    Processing
                                  </SwButton>
                                )}
                              </div>
                            }
                          >
                            <PrinterScanner
                              ref={printerAccessRef}
                              onClose={() => setShowPrinterAccess(false)}
                            />
                          </SwOffCanvas>
                        </div>
                      </div>
                    </div>

                    {/* Testing Survey -- Remove after UI */}
                    <div className="SurveyList_container_Body d-none">
                      <div>
                        <div className="opinionBanner SurveyBanner">
                          <>
                            <div>
                              <h2>
                                Move-in survey
                                <div className="RemainingLocations">
                                  <i className="bi bi-geo-alt-fill" />
                                  <span>45 Locations Remaining </span>
                                </div>
                              </h2>
                              <p>
                                We value your opinion! Tell us about your
                                Move-In experience.
                              </p>
                              <SwButton
                                variant="primary"
                                size='sm'
                                icon={<i className="bi bi-arrow-right" />}
                                iconPosition="end"
                              >
                                Start Survey
                              </SwButton>
                            </div>
                            <div className="opinionBannericon">
                              <img
                                src="img/move-in-survey-icon.png"
                                alt="Survey Icon"
                              />
                            </div>
                          </>
                        </div>
                      </div>
                    </div>

                    {/* //for Survey Part */}
                    {surveyData.length > 0 ? (
                      <div className="SurveyList_container_Body">
                        {surveyData.map((survey, index) => (
                          <div key={index}>
                            <div className="opinionBanner SurveyBanner">
                              {survey.check_move_in === 1 && (
                                <>
                                  <div>
                                    <h2>
                                      Move-in survey
                                      <div className="RemainingLocations">
                                        <i className="bi bi-geo-alt-fill" />
                                        <span>
                                          {survey.locationData.length}{' '}
                                          {survey.locationData.length > 1
                                            ? 'Locations'
                                            : 'Location'}{' '}
                                          Remaining
                                        </span>
                                      </div>
                                    </h2>
                                    <p>
                                      We value your opinion! Tell us about your
                                      Move-In experience.
                                    </p>
                                    <SwButton
                                      variant="primary"
                                      size='sm'
                                      onClick={() => setActiveSurveyIndex(index)}
                                      icon={<i className="bi bi-arrow-right" />}
                                      iconPosition="end"
                                    >
                                      Start Survey
                                    </SwButton>
                                  </div>
                                  <div className="opinionBannericon">
                                    <img
                                      src="img/move-in-survey-icon.png"
                                      alt="Survey Icon"
                                    />
                                  </div>
                                </>
                              )}
                              {survey.check_move_in === 3 && (
                                <>
                                  <div>
                                    <h2>
                                      Customer Satisfaction Survey
                                      <div className="RemainingLocations">
                                        <i className="bi bi-geo-alt-fill" />
                                        <span>
                                          {survey.locationData.length}{' '}
                                          {survey.locationData.length > 1
                                            ? 'Locations'
                                            : 'Location'}{' '}
                                          Remaining
                                        </span>
                                      </div>
                                    </h2>
                                    <p>
                                      Tell us how we're doing: take a moment to
                                      rate your experience!
                                    </p>
                                    <SwButton
                                      variant="primary"
                                      size='sm'
                                      onClick={() => setActiveSurveyIndex(index)}
                                      icon={<i className="bi bi-arrow-right" />}
                                      iconPosition="end"
                                    >
                                      Start Survey
                                    </SwButton>
                                  </div>
                                  <div className="opinionBannericon">
                                    <img
                                      src="img/newSurveyIcon.svg"
                                      alt="Survey Icon"
                                    />
                                  </div>
                                </>
                              )}

                              {survey.check_move_in === 2 && (
                                <>
                                  <div>
                                    <h2>
                                      Move-out Survey
                                      <div className="RemainingLocations">
                                        <i className="bi bi-geo-alt-fill" />
                                        <span>
                                          {survey.locationData.length}{' '}
                                          {survey.locationData.length > 1
                                            ? 'Locations'
                                            : 'Location'}{' '}
                                          Remaining
                                        </span>
                                      </div>
                                    </h2>
                                    <p>
                                      We value your opinion! Tell us about your
                                      Move-out experience.
                                    </p>
                                    <SwButton
                                      variant="primary"
                                      size='sm'
                                      onClick={() => setActiveSurveyIndex(index)}
                                      icon={<i className="bi bi-arrow-right" />}
                                      iconPosition="end"
                                    >
                                      Start Survey
                                    </SwButton>
                                  </div>
                                  <div className="opinionBannericon">
                                    <img
                                      src="img/move-out-survey-icon.png"
                                      alt="Survey Icon"
                                    />
                                  </div>
                                </>
                              )}
                            </div>
                            <FeedbackRating
                              surveyProps={[survey]}
                              show={activeSurveyIndex === index}
                              onClose={() => setActiveSurveyIndex(null)}
                              apiDataSurvey={getSurvey}
                            />
                          </div>
                        ))}
                      </div>
                    ) : (
                      ''
                    )}
                    {/* // survey parts end here */}
                  </div>
                </div>

                <div className="col-lg-5">
        

                  <ExtendedV2 />

                  {/* {!showExtendedBookingHoursForDlf */}

                  {/* <LightGrid /> */}

                  <div className="Dashboard_Card CspocUserGuideCard">
                    <div className="Dashboard_Card_Header">
                      <div className="d-flex align-items-center justify-content-between">
                        <div>
                          <h2 className="mb-1">Client Portal User Guide</h2>
                          <h5 className="d-flex justify-content-between align-items-center">
                            <span>
                              Explore all client portal features by going
                              through the User Guide
                            </span>
                          </h5>
                        </div>
                        <a
                          className="UserGuide d-flex align-items-center"
                          href="https://smartworks-production.s3.ap-southeast-1.amazonaws.com/assets/CSPOC+Features+Guide.pdf"
                          target="_blank"
                        >
                          <img src="./img/new-dashboard/VideoDown-icon.svg" />
                        </a>
                      </div>
                    </div>
                    <div className="Dashboard_Card_Body">
                      <div className="Dashboard_VideoBox">
                        <video
                          width="100%"
                          poster=""
                          muted
                          autoPlay
                          controls
                          loop
                        >
                          <source
                            src="https://d2jovvsod2x1gg.cloudfront.net/csp-files/Introducing-C-SPOC-Portal-Smartworks-720p.mp4"
                            type="video/mp4"
                          />
                        </video>
                      </div>

                      {/* <div className='Dashboard_VideoBox'>
                      <iframe
                        src="https://www.youtube.com/embed/V4BgBQPQL_c?rel=0&autoplay=1&mute=1"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; mute; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin"
                        allowfullscreen
                        autoplay
                      ></iframe>
                    </div> */}
                    </div>
                  </div>

                  {/* Skywatch Card */}
                  {completeData.length == 0 ? (
                    ''
                  ) : (
                    <div className="Dashboard_Card">
                      <Slider
                        className=""
                        autoplay={true}
                        autoplaySpeed={5000}
                        pauseOnHover={true}
                        infinite={Slider.length > 1}
                        slidesToShow={1}
                        slidesToScroll={1}
                        arrows={false}
                        dots={false}
                      >
                        <div>
                          <SkyWatch onCompleteData={handleCompleteData} />
                        </div>
                      </Slider>
                    </div>
                  )}

                  {/* // Notice Board Part */}
                  {UserObj?.company_id != process.env.REACT_APP_TALBOT_COM_ID &&
                  UserObj?.company_id != process.env.REACT_APP_PROZO_COM_ID &&
                  UserObj?.company_id != process.env.REACT_APP_ASL_COM_ID ? (
                    <div className="Dashboard_Card New_dBoardCard">
                      <div className="Dashboard_Card_Header">
                        <h2>Notice board</h2>
                      </div>
                      <div className="NoticeSliderContainer">
                        {UserObj?.company_id ==
                        process.env.REACT_APP_OCWEN_COM_ID ? (
                          <>
                            <Slider {...NoticeSliderSetting}>
                              {document && document !== 0 ? (
                                <div>
                                  <div className="slider_access_review_status_box slider_access_Black">
                                    <div>
                                      <div className="days_right_box sts_complete">
                                        <img src="/img/legal-icon56.svg" />
                                      </div>
                                    </div>

                                    <div>
                                      <div className="rule_icon">&nbsp;</div>

                                      <h4>
                                        <strong>{document} documents</strong>{' '}
                                        have been updated for your review.
                                      </h4>

                                      <div className="access_review_status_button">
                                        <SwButton
                                          variant="dark"
                                          size="sm"
                                          icon={
                                            <i className="bi bi-arrow-right" />
                                          }
                                          iconPosition="end"
                                          onClick={onReviewClick}
                                        >
                                          Review
                                        </SwButton>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                ''
                              )}
                            </Slider>
                          </>
                        ) : UserObj?.company_id !=
                            process.env.REACT_APP_TALBOT_COM_ID &&
                          UserObj?.company_id !=
                            process.env.REACT_APP_PROZO_COM_ID &&
                          UserObj?.company_id !=
                            process.env.REACT_APP_OCWEN_COM_ID &&
                          UserObj?.company_id !=
                            process.env.REACT_APP_ASL_COM_ID ? (
                          reviewData.leftDays > 0 ||
                          currentDay <= Number(reviewData.monthlyReviewDay) ? (
                            <>
                              <Slider {...NoticeSliderSetting}>
                                {document && document !== 0 ? (
                                  <div>
                                    <div className="slider_access_review_status_box slider_access_Black">
                                      <div>
                                        <div className="days_right_box sts_complete">
                                          <img src="/img/legal-icon56.svg" />
                                        </div>
                                      </div>

                                      <div>
                                        <div className="rule_icon">&nbsp;</div>

                                        <h4>
                                          <strong>{document} documents</strong>{' '}
                                          have been updated for your review.
                                        </h4>

                                        <div className="access_review_status_button">
                                          <SwButton
                                            variant="dark"
                                            size="sm"
                                            icon={
                                              <i className="bi bi-arrow-right" />
                                            }
                                            iconPosition="end"
                                            onClick={onReviewClick}
                                          >
                                            Review
                                          </SwButton>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  ''
                                )}

                                <div>
                                  <div
                                    className={
                                      'slider_access_review_status_box ' +
                                      (reviewData.pendingUserList &&
                                      reviewData.pendingUserList.length == 0
                                        ? 'w-100jjj'
                                        : '')
                                    }
                                  >
                                    <div>
                                      {reviewData.leftDays > 3 &&
                                      reviewData.pendingLocCount > 0 ? (
                                        <div className="days_right_box">
                                          <div className="dys">
                                            <h3>{reviewData.leftDays}</h3>
                                            <span className="d-block">
                                              days left
                                            </span>
                                          </div>
                                        </div>
                                      ) : // when left days <= 3
                                      reviewData.leftDays > 0 &&
                                        reviewData.leftDays <= 3 ? (
                                        <div className="days_right_box few_left">
                                          <div className="dys">
                                            <h3>{reviewData.leftDays}</h3>
                                            <span className="d-block">
                                              days left
                                            </span>
                                          </div>
                                        </div>
                                      ) : reviewData.pendingLocCount == 0 &&
                                        currentDay <=
                                          Number(
                                            reviewData.monthlyReviewDay,
                                          ) ? (
                                        <div className="days_right_box sts_complete">
                                          <div className="dys">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="100"
                                              height="100"
                                              viewBox="0 0 100 100"
                                              fill="none"
                                            >
                                              <g clip-path="url(#clip0_277_1847)">
                                                <path
                                                  d="M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z"
                                                  fill="#32BA7C"
                                                />
                                                <path
                                                  d="M37.2241 72.555L62.9339 98.2648C84.2273 92.5866 100 73.1859 100 49.9998C100 49.5266 100 49.0534 100 48.5802L79.8109 29.9683L37.2241 72.555Z"
                                                  fill="#0AA06E"
                                                />
                                                <path
                                                  d="M51.2621 61.1989C53.4703 63.4071 53.4703 67.1926 51.2621 69.4008L46.6879 73.975C44.4797 76.1832 40.6942 76.1832 38.486 73.975L18.4545 53.7857C16.2463 51.5775 16.2463 47.792 18.4545 45.5838L23.0286 41.0097C25.2368 38.8015 29.0223 38.8015 31.2305 41.0097L51.2621 61.1989Z"
                                                  fill="white"
                                                />
                                                <path
                                                  d="M68.77 26.3407C70.9782 24.1325 74.7637 24.1325 76.9719 26.3407L81.5461 30.9149C83.7543 33.1231 83.7543 36.9085 81.5461 39.1167L46.8458 73.6593C44.6375 75.8675 40.8521 75.8675 38.6439 73.6593L34.0697 69.0852C31.8615 66.877 31.8615 63.0915 34.0697 60.8833L68.77 26.3407Z"
                                                  fill="white"
                                                />
                                              </g>
                                              <defs>
                                                <clipPath id="clip0_277_1847">
                                                  <rect
                                                    width="100"
                                                    height="100"
                                                    fill="white"
                                                  />
                                                </clipPath>
                                              </defs>
                                            </svg>
                                          </div>
                                        </div>
                                      ) : (
                                        ''
                                      )}
                                    </div>
                                    <div>
                                      <div className="rule_icon">
                                        <i className="bi bi-list-check" />
                                      </div>
                                      <h4>
                                        Member review for {reviewData.monthName}
                                        {reviewData.pendingLocCount == 0 &&
                                        currentDay <=
                                          reviewData.monthlyReviewDay
                                          ? ' is completed '
                                          : ' is pending '}
                                        {reviewData.pendingLocCount > 1 ? (
                                          <span className="pending_location">
                                            for {reviewData.pendingLocCount}{' '}
                                            locations
                                          </span>
                                        ) : (
                                          ''
                                        )}
                                      </h4>
                                      {reviewData.pendingLocCount != 0 ? (
                                        <div className="access_review_status_button">
                                          <SwButton
                                            variant="dark"
                                            size="sm"
                                            icon={
                                              <i className="bi bi-arrow-right" />
                                            }
                                            iconPosition="end"
                                            onClick={handleClick1}
                                          >
                                            Start review
                                          </SwButton>
                                        </div>
                                      ) : (
                                        ''
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </Slider>
                            </>
                          ) : //when left days is 0.
                          reviewData.leftDays == 0 &&
                            currentDay > Number(reviewData.monthlyReviewDay) ? (
                            <>
                              <Slider {...NoticeSliderSetting}>
                                {document && document !== 0 ? (
                                  <div>
                                    <div
                                      className="slider_access_review_status_box slider_access_Black"
                                      style={{ height: '188px' }}
                                    >
                                      <div>
                                        <div className="days_right_box sts_complete">
                                          <img src="/img/legal-icon56.svg" />
                                        </div>
                                      </div>

                                      <div>
                                        <div className="rule_icon">&nbsp;</div>

                                        <h4>
                                          <strong>{document} documents</strong>{' '}
                                          have been updated for your review.
                                        </h4>

                                        <div className="access_review_status_button">
                                          <SwButton
                                            variant="dark"
                                            size="sm"
                                            icon={
                                              <i className="bi bi-arrow-right" />
                                            }
                                            iconPosition="end"
                                            onClick={onReviewClick}
                                          >
                                            Review
                                          </SwButton>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  ''
                                )}
                                <div>
                                  <div className="slider_access_review_status_box">
                                    <div>
                                      <div className="days_right_box left_0">
                                        <div className="dys">
                                          <h3>{reviewData.leftDays}</h3>
                                          <span className="d-block">
                                            days left
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                    <div>
                                      <div className="rule_icon">
                                        <i className="bi bi-list-check" />
                                      </div>
                                      <h4>
                                        Member review for {reviewData.monthName}{' '}
                                        is due now
                                      </h4>
                                      {reviewData.pendingLocCount != 0 ? (
                                        <div className="access_review_status_button">
                                          <SwButton
                                            variant="dark"
                                            size="sm"
                                            icon={
                                              <i className="bi bi-arrow-right" />
                                            }
                                            iconPosition="end"
                                            onClick={handleClick1}
                                          >
                                            Start review
                                          </SwButton>
                                        </div>
                                      ) : (
                                        ''
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </Slider>
                            </>
                          ) : UserObj?.company_id !=
                              process.env.REACT_APP_TALBOT_COM_ID &&
                            UserObj?.company_id !=
                              process.env.REACT_APP_PROZO_COM_ID &&
                            UserObj?.company_id !=
                              process.env.REACT_APP_OCWEN_COM_ID &&
                            UserObj?.company_id !=
                              process.env.REACT_APP_ASL_COM_ID &&
                            UserObj?.company_id !=
                              process.env.REACT_APP_SMARTWORKS_COM_ID ? (
                            <>
                              <Slider {...NoticeSliderSetting}>
                                {document && document !== 0 ? (
                                  <div>
                                    <div
                                      className="slider_access_review_status_box slider_access_Black"
                                      style={{ height: '188px' }}
                                    >
                                      <div>
                                        <div className="days_right_box sts_complete">
                                          <img src="/img/legal-icon56.svg" />
                                        </div>
                                      </div>

                                      <div>
                                        <div className="rule_icon">&nbsp;</div>

                                        <h4>
                                          <strong>{document} documents</strong>{' '}
                                          have been updated for your review.
                                        </h4>

                                        <div className="access_review_status_button">
                                          <SwButton
                                            variant="dark"
                                            size="sm"
                                            icon={
                                              <i className="bi bi-arrow-right" />
                                            }
                                            iconPosition="end"
                                            onClick={onReviewClick}
                                          >
                                            Review
                                          </SwButton>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  ''
                                )}
                              </Slider>
                            </>
                          ) : (
                            <div
                              className={
                                spinner != true ? 'loader disable' : 'loader'
                              }
                              style={{ position: 'relative' }}
                            >
                              <img
                                className=""
                                src="https://smartworks-production.s3.ap-southeast-1.amazonaws.com/assets/loader-sw.gif"
                                alt="Loder"
                              />
                            </div>
                          )
                        ) : (
                          ''
                        )}
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            ) : (
              ''
            )}

            <section className="products-tab-section" id="sw-products">
              <div className="container-no swpmc1">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="sw-tab-container">
                      <Tabs
                        defaultActiveKey="tab1"
                        id="myTab"
                        className="nav nav-tabs"
                      >
                        <Tab
                          eventKey="tab1"
                          title={
                            <div className="nav-link">
                              <div className="tab-nav-img">
                                <img
                                  src="assets/images/tab-img1.svg"
                                  loading="lazy"
                                  onClick={() => handleClick('meetingRoom')}
                                />
                              </div>
                              <h4>Meeting Room Scheduler</h4>
                            </div>
                          }
                        >
                          {/* 🔽 YOUR ORIGINAL TAB 1 CONTENT — UNCHANGED */}
                          <div className="tab-pane" id="tab1" role="tabpanel">
                            {/* KEEP EVERYTHING AS IS HERE */}
                            <div className="tab-data">
                              <div className="SwHeading">
                                <h2>Meeting Room Scheduler</h2>
                              </div>
                              <div className="row pt-2">
                                <div className="col-lg-6">
                                  <p>
                                    Modern Meeting &amp; Conference Room Booking
                                    System. Book meetings with your mobile
                                    number, schedule them in advance, and manage
                                    booking with our IoT-enabled Meeting Rooms!
                                  </p>
                                  <p>
                                    IoT powered Flexible solution for
                                    comprehensive optimization of meeting rooms
                                    by finding a suitable space and time,
                                    schedule &amp; secure the meeting space, and
                                    book in moments.
                                  </p>
                                  <ul className="tab-data-listview">
                                    <li>
                                      <span>
                                        Control amenities such as projector,
                                        lights, TV etc., post check-in.
                                      </span>
                                    </li>
                                    <li>
                                      <span>
                                        Order snacks &amp; beverages from the
                                        local pantry.
                                      </span>
                                    </li>
                                    <li>
                                      <span>
                                        Extend and manage the meeting if it is
                                        running over
                                      </span>
                                    </li>
                                    <li>
                                      <span>
                                        Checks you out automatically post
                                        scheduled time
                                      </span>
                                    </li>
                                    <li>
                                      <span>
                                        Deep insights in to meeting room
                                        utilization with Smart Analytics
                                      </span>
                                    </li>
                                    <li>
                                      <span>
                                        Reduce time to hunt for Meeting Room or
                                        lurking outside waiting for a meeting to
                                        end.
                                      </span>
                                    </li>
                                  </ul>
                                  <SwButton
                                    icon={<i className="bi bi-arrow-right" />}
                                    iconPosition="end"
                                    onClick={() =>
                                      sendProductEnquiryMail(
                                        'Meeting Room Scheduler',
                                      )
                                    }
                                    variant="primary"
                                  >
                                    I am Interested
                                  </SwButton>
                                </div>
                                <div className="col-lg-6">
                                  <div className="tab-data-img">
                                    <Slider
                                      className=""
                                      pauseOnHover={true}
                                      autoplay={true}
                                      autoplaySpeed={5000}
                                      slidesToShow={1}
                                      slidesToScroll={1}
                                      arrows={false}
                                      dots={true}
                                      infinite={true}
                                    >
                                      <img
                                        src="assets/images/tab-slider-img/meeting_room_1.png"
                                        className="img-fluid"
                                        loading="lazy"
                                      />
                                      <img
                                        src="assets/images/tab-slider-img/meeting_room_2.png"
                                        className="img-fluid"
                                        loading="lazy"
                                      />
                                      <img
                                        src="assets/images/tab-slider-img/meeting_room_3.png"
                                        className="img-fluid"
                                        loading="lazy"
                                      />
                                      <img
                                        src="assets/images/tab-slider-img/meeting_room_4.png"
                                        className="img-fluid"
                                        loading="lazy"
                                      />
                                    </Slider>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Tab>

                        <Tab
                          eventKey="tab2"
                          title={
                            <div className="nav-link">
                              <div className="tab-nav-img">
                                <img
                                  src="assets/images/tab-img2.svg"
                                  loading="lazy"
                                  onClick={() => handleClick('hotDesking')}
                                />
                              </div>
                              <h4>Hot Desking (Flexi Desk)</h4>
                            </div>
                          }
                        >
                          <div className="tab-pane" id="tab2" role="tabpanel">
                            {/* ORIGINAL TAB 2 CONTENT — AS IS */}
                            <div className="tab-data">
                              <div className="SwHeading">
                                <h2>Hot Desking (Flexi Desk)</h2>
                              </div>
                              <div className="row pt-2">
                                <div className="col-lg-6">
                                  <p>
                                    Bringing you the flexibility that works for
                                    you. Determine the available desks and
                                    reserve based on workspace's capacity using
                                    Smartworks Super App.
                                  </p>
                                  <p>
                                    Easy desk booking for Hybrid workspace. The
                                    workplace requires flexible seating to
                                    effectively promote communication &amp;
                                    collaboration.
                                  </p>
                                  <ul className="tab-data-listview">
                                    <li>
                                      <span>
                                        Flexible customization workspace
                                        booking.
                                      </span>
                                    </li>
                                    <li>
                                      <span>
                                        IoT enabled Smart workstation.{' '}
                                      </span>
                                    </li>
                                    <li>
                                      <span>
                                        Optimize workspace utilization to create
                                        a flexible workspace experience.
                                      </span>
                                    </li>
                                    <li>
                                      <span>
                                        Book your seat simply from your
                                        Smartworks mobile app and relax with
                                        knowledge that it will be waiting for
                                        you when you arrive.
                                      </span>
                                    </li>
                                    <li>
                                      <span>QR-based booking. </span>
                                    </li>
                                  </ul>
                                  <SwButton
                                    icon={<i className="bi bi-arrow-right" />}
                                    iconPosition="end"
                                    onClick={() =>
                                      sendProductEnquiryMail(
                                        'Hot Desking (Flexi Desk)',
                                      )
                                    }
                                  >
                                    I am Interested
                                  </SwButton>
                                </div>
                                <div className="col-lg-6">
                                  <div className="tab-data-img">
                                    <Slider
                                      className=""
                                      pauseOnHover={true}
                                      autoplay={true}
                                      autoplaySpeed={5000}
                                      slidesToShow={1}
                                      slidesToScroll={1}
                                      arrows={false}
                                      dots={true}
                                      infinite={true}
                                    >
                                      <img
                                        src="assets/images/tab-slider-img/seat_booking_1.png"
                                        className="img-fluid"
                                        loading="lazy"
                                      />
                                      <img
                                        src="assets/images/tab-slider-img/seat_booking_2.png"
                                        className="img-fluid"
                                        loading="lazy"
                                      />
                                    </Slider>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Tab>

                        <Tab
                          eventKey="tab3"
                          title={
                            <div className="nav-link">
                              <div className="tab-nav-img">
                                <img
                                  src="assets/images/tab-img5.svg"
                                  loading="lazy"
                                  onClick={() =>
                                    handleClick('visitormanagesys')
                                  }
                                />
                              </div>
                              <h4>Visitor Management System</h4>
                            </div>
                          }
                        >
                          <div className="tab-pane" id="tab3" role="tabpanel">
                            {/* ORIGINAL TAB 3 CONTENT */}
                            <div className="tab-data">
                              <div className="SwHeading">
                                <h2>Visitors Management</h2>
                              </div>
                              <div className="row pt-2">
                                <div className="col-lg-6">
                                  <h5>
                                    A seamless and secure workspace experience!
                                  </h5>
                                  <p>
                                    Visitor Management Solution made smarter.
                                    Set a hassle-free welcoming atmosphere.
                                    Track and manage your visitors who enter
                                    your workplace in a digital way.
                                  </p>
                                  <ul className="tab-data-listview">
                                    <li>
                                      <span>
                                        Visitors can walk-in &amp; notify the
                                        Hosts.
                                      </span>
                                    </li>
                                    <li>
                                      <span>
                                        VMS with Thermal Scanner also ensures
                                        safety of your employees by ensuring
                                        mandatory Face mask, and appropriate
                                        Body temperature.
                                      </span>
                                    </li>
                                    <li>
                                      <span>
                                        Smartworks mobile app helps to
                                        pre-invite visitors.
                                      </span>
                                    </li>
                                    <li>
                                      <span>
                                        Self-check-ins &amp; check-outs.{' '}
                                      </span>
                                    </li>
                                    <li>
                                      <span>
                                        Automated notifications to the guests
                                        &amp; host.
                                      </span>
                                    </li>
                                    <li>
                                      <span>
                                        Facial-recognition for repeated visitors
                                        for faster check-ins.
                                      </span>
                                    </li>
                                    <li>
                                      <span>
                                        Analytics with insights such as Visitors
                                        count, status &amp; insights.
                                      </span>
                                    </li>
                                  </ul>
                                  <SwButton
                                    icon={<i className="bi bi-arrow-right" />}
                                    iconPosition="end"
                                    onClick={() =>
                                      sendProductEnquiryMail(
                                        'Visitors Management',
                                      )
                                    }
                                  >
                                    {' '}
                                    I am Interested
                                  </SwButton>
                                </div>
                                <div className="col-lg-6">
                                  <div className="tab-data-img">
                                    <Slider
                                      className=""
                                      pauseOnHover={true}
                                      autoplay={true}
                                      autoplaySpeed={5000}
                                      slidesToShow={1}
                                      slidesToScroll={1}
                                      arrows={false}
                                      dots={true}
                                      infinite={true}
                                    >
                                      <img
                                        src="assets/images/tab-slider-img/visitor_1.png"
                                        className="img-fluid"
                                        loading="lazy"
                                      />
                                      <img
                                        src="assets/images/tab-slider-img/visitor_2.png"
                                        className="img-fluid"
                                        loading="lazy"
                                      />
                                      <img
                                        src="assets/images/tab-slider-img/visitor_3.png"
                                        className="img-fluid"
                                        loading="lazy"
                                      />
                                    </Slider>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Tab>

                        <Tab
                          eventKey="tab4"
                          title={
                            <div className="nav-link">
                              <div className="tab-nav-img">
                                <img
                                  src="assets/images/Attendance management app.png"
                                  loading="lazy"
                                  onClick={() =>
                                    handleClick('attendancemanage')
                                  }
                                />
                              </div>
                              <h4>Attendance Management App</h4>
                            </div>
                          }
                        >
                          <div className="tab-pane" id="tab4" role="tabpanel">
                            {/* ORIGINAL TAB 4 CONTENT */}
                            <div className="tab-data">
                              <div className="SwHeading">
                                <h2>Attendance Management APP</h2>
                              </div>
                              <div className="row pt-2">
                                <div className="col-lg-6">
                                  <h5>
                                    A seamless and accurate Attendance data
                                    management System!
                                  </h5>
                                  <p>
                                    An attendance management app that uses face
                                    recognition technology to precisely monitor
                                    and administer attendance records.
                                  </p>
                                  <ul className="tab-data-listview">
                                    <li>
                                      <span>
                                        Mark attendance with a faster and more
                                        hygienic for employees with a
                                        contactless face recognition system.
                                      </span>
                                    </li>
                                    <li>
                                      <span>
                                        Get insights like - count of Total
                                        Employees in, Half day, present, absent,
                                        status.
                                      </span>
                                    </li>
                                    <li>
                                      <span>
                                        Daily, Monthly and User specific
                                        attendance reports of employees.
                                      </span>
                                    </li>
                                    <li>
                                      <span>
                                        Easy self-check-ins & check-outs.
                                      </span>
                                    </li>
                                    <li>
                                      <span>
                                        Additional layer of security to prevent
                                        proxy attendance.
                                      </span>
                                    </li>
                                    <li>
                                      <span>
                                        Easily integrate with other software
                                        systems, such as payroll software, to
                                        automate payroll processing for monthly
                                        payrolls.
                                      </span>
                                    </li>
                                  </ul>
                                  <SwButton
                                    icon={<i className="bi bi-arrow-right" />}
                                    iconPosition="end"
                                    onClick={() =>
                                      sendProductEnquiryMail(
                                        'Attendance Management App',
                                      )
                                    }
                                  >
                                    I am Interested
                                  </SwButton>
                                </div>
                                <div className="col-lg-6">
                                  <div className="tab-data-img">
                                    <Slider
                                      className=""
                                      pauseOnHover={true}
                                      autoplay={true}
                                      autoplaySpeed={5000}
                                      slidesToShow={1}
                                      slidesToScroll={1}
                                      arrows={false}
                                      dots={true}
                                      infinite={true}
                                    >
                                      <img
                                        src="assets/images/tab-slider-img/AMS 01.png"
                                        className="img-fluid"
                                        loading="lazy"
                                      />
                                      <img
                                        src="assets/images/tab-slider-img/AMS-2.png"
                                        className="img-fluid"
                                        loading="lazy"
                                      />
                                    </Slider>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Tab>

                        <Tab
                          eventKey="tab5"
                          title={
                            <div className="nav-link">
                              <div className="tab-nav-img">
                                <img
                                  src="assets/images/tab-img3.svg"
                                  loading="lazy"
                                  onClick={() => handleClick('smartworks')}
                                />
                              </div>
                              <h4>Smartworks Super App</h4>
                            </div>
                          }
                        >
                          <div className="tab-pane" id="tab5" role="tabpanel">
                            {/* ORIGINAL TAB 5 CONTENT */}
                            <div className="tab-data">
                              <div className="SwHeading">
                                <h2>Smartworks Super App </h2>
                              </div>
                              <div className="row pt-2">
                                <div className="col-lg-6">
                                  <p>
                                    Here is a Super App for all your office
                                    needs! From booking meeting rooms,
                                    Flexi-desk to booking your slot at the
                                    recreational areas. Dispense your favourite
                                    beverage or order food with a simple click.
                                    Give feedback, raise a request or query, or
                                    access the community page for insightful
                                    articles and posts. Technology has always
                                    been an integral part of how Smartworks
                                    functions.
                                  </p>
                                  <ul className="tab-data-listview">
                                    <li>
                                      <span>
                                        Digital Access in your office space with
                                        a tap.
                                      </span>
                                    </li>
                                    <li>
                                      <span>
                                        Daily feeds of articles and posts by
                                        your team mates.
                                      </span>
                                    </li>
                                    <li>
                                      <span>
                                        Services like touchless beverage
                                        dispensing just by scanning QR code.
                                      </span>
                                    </li>
                                    <li>
                                      <span>
                                        Place order for your favorite food just
                                        in few clicks.
                                      </span>
                                    </li>
                                    <li>
                                      <span>
                                        Search and Book available Meeting
                                        room/Flexi-seat all from your Super App.
                                      </span>
                                    </li>
                                    <li>
                                      <span>
                                        Want to relax, Book power nap session in
                                        Sleeping pod or book your favorite game.
                                      </span>
                                    </li>
                                  </ul>
                                  <SwButton
                                    icon={<i className="bi bi-arrow-right" />}
                                    iconPosition="end"
                                    onClick={() =>
                                      sendProductEnquiryMail(
                                        'Smartworks Super App',
                                      )
                                    }
                                  >
                                    I am Interested
                                  </SwButton>
                                </div>
                                <div className="col-lg-6">
                                  <div className="tab-data-img">
                                    <Slider
                                      className=""
                                      pauseOnHover={true}
                                      autoplay={true}
                                      autoplaySpeed={5000}
                                      slidesToShow={1}
                                      slidesToScroll={1}
                                      arrows={false}
                                      dots={true}
                                      infinite={true}
                                    >
                                      <img
                                        src="assets/images/tab-slider-img/mobile_app_1.png"
                                        className="img-fluid"
                                        loading="lazy"
                                      />
                                      <img
                                        src="assets/images/tab-slider-img/mobile_app_2.png"
                                        className="img-fluid"
                                        loading="lazy"
                                      />
                                      <img
                                        src="assets/images/tab-slider-img/mobile_app_3.png"
                                        className="img-fluid"
                                        loading="lazy"
                                      />
                                    </Slider>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Tab>

                        <Tab
                          eventKey="tab7"
                          title={
                            <div className="nav-link">
                              <div className="tab-nav-img">
                                <img
                                  src="assets/images/tab-img4.svg"
                                  loading="lazy"
                                  onClick={() => handleClick('feedback')}
                                />
                              </div>
                              <h4>Smart feedback</h4>
                            </div>
                          }
                        >
                          <div className="tab-pane" id="tab7" role="tabpanel">
                            {/* ORIGINAL TAB 7 CONTENT */}
                            <div className="tab-data">
                              <div className="SwHeading">
                                <h2>Smart Feedback </h2>
                              </div>
                              <div className="row pt-2">
                                <div className="col-lg-6">
                                  <p>
                                    Your feedback is valuable to us. Use our
                                    Smartworks Super App to share feedback with
                                    an easy smiley-based feedback management
                                    system, raise a ticket for your concern and
                                    get your query resolved instantly.
                                  </p>
                                  <ul className="tab-data-listview">
                                    <li>
                                      <span>
                                        Save time and money on collecting and
                                        organizing feedback.
                                      </span>
                                    </li>
                                    <li>
                                      <span>
                                        Provides opportunity to improve
                                        services.
                                      </span>
                                    </li>
                                    <li>
                                      <span>
                                        Automatic ticket generation in case of
                                        negative feedback.
                                      </span>
                                    </li>
                                    <li>
                                      <span>
                                        Prompt resolution of ticket raised.
                                      </span>
                                    </li>
                                    <li>
                                      <span>
                                        Significantly enhance productivity by
                                        providing continuous feedback &amp;
                                        streamlining tedious processes.
                                      </span>
                                    </li>
                                  </ul>
                                  <SwButton
                                    icon={<i className="bi bi-arrow-right" />}
                                    iconPosition="end"
                                    onClick={() =>
                                      sendProductEnquiryMail('Smart Feedback')
                                    }
                                  >
                                    {' '}
                                    I am Interested
                                  </SwButton>
                                </div>
                                <div className="col-lg-6">
                                  <div className="tab-data-img">
                                    <Slider
                                      className=""
                                      pauseOnHover={true}
                                      autoplay={true}
                                      autoplaySpeed={5000}
                                      slidesToShow={1}
                                      slidesToScroll={1}
                                      arrows={false}
                                      dots={true}
                                      infinite={true}
                                    >
                                      <img
                                        src="assets/images/tab-slider-img/feedback_1.png"
                                        className="img-fluid"
                                        loading="lazy"
                                      />
                                      <img
                                        src="assets/images/tab-slider-img/feedback_2.png"
                                        className="img-fluid"
                                        loading="lazy"
                                      />
                                      <img
                                        src="assets/images/tab-slider-img/feedback_3.png"
                                        className="img-fluid"
                                        loading="lazy"
                                      />
                                    </Slider>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Tab>

                        <Tab
                          eventKey="tab8"
                          title={
                            <div className="nav-link">
                              <div className="tab-nav-img">
                                <img
                                  src="assets/images/tab-img6.svg"
                                  loading="lazy"
                                  onClick={() => handleClick('pantry')}
                                />
                              </div>
                              <h4>Pantry Management</h4>
                            </div>
                          }
                        >
                          <div className="tab-pane" id="tab8" role="tabpanel">
                            {/* ORIGINAL TAB 8 CONTENT */}
                            <div className="tab-data">
                              <div className="SwHeading">
                                <h2>Pantry Management </h2>
                              </div>
                              <div className="row pt-2">
                                <div className="col-lg-6">
                                  <p>
                                    Need a refreshing cup of hot coffee in the
                                    middle of meeting, no worries simply order
                                    from the Food ordering app with in-built
                                    menu and get your orders delivered in no
                                    time.
                                  </p>
                                  <ul className="tab-data-listview">
                                    <li>
                                      <span>Extend Meeting time. </span>
                                    </li>
                                    <li>
                                      <span>
                                        Get hot cup of your favorite beverage
                                        delivered to you within clicks.
                                      </span>
                                    </li>
                                    <li>
                                      <span>
                                        Pantry boy receives real time orders,
                                        with status of order placed.
                                      </span>
                                    </li>
                                    <li>
                                      <span>
                                        You can also call someone simply from
                                        our Food ordering app.
                                      </span>
                                    </li>
                                  </ul>
                                  <SwButton
                                    icon={<i className="bi bi-arrow-right" />}
                                    iconPosition="end"
                                    onClick={() =>
                                      sendProductEnquiryMail(
                                        'Pantry Management',
                                      )
                                    }
                                  >
                                    I am Interested
                                  </SwButton>
                                </div>
                                <div className="col-lg-6">
                                  <div className="tab-data-img">
                                    <Slider
                                      className=""
                                      pauseOnHover={true}
                                      autoplay={true}
                                      autoplaySpeed={5000}
                                      slidesToShow={1}
                                      slidesToScroll={1}
                                      arrows={false}
                                      dots={true}
                                      infinite={true}
                                    >
                                      <img
                                        src="assets/images/tab-slider-img/pantry_1.png"
                                        className="img-fluid"
                                        loading="lazy"
                                      />
                                      <img
                                        src="assets/images/tab-slider-img/pantry_2.png"
                                        className="img-fluid"
                                        loading="lazy"
                                      />
                                      <img
                                        src="assets/images/tab-slider-img/pantry_3.png"
                                        className="img-fluid"
                                        loading="lazy"
                                      />
                                    </Slider>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Tab>
                      </Tabs>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className="app-download-section pt-4 pb-0" id="sw-app">
              <div className="container-no swpmc1-no px-0">
                <div className="app-download-container">
                  <div className="row">
                    <div className="col-lg-8">
                      <div className="download-txt">
                        <div className="txt-tp">
                          Download Free Smartworks app
                        </div>

                        <h2>Stay on top with smartworks</h2>

                        <p>
                          Download the Smartworks app to start reserving your
                          nearest flexi desk or meeting room. Cancel any time.
                        </p>
                        <ul>
                          <li>
                            <span>
                              Stay connected to your community wherever you are.
                            </span>
                          </li>
                          <li>
                            <span>Stay updated about your workspace.</span>
                          </li>
                          <li>
                            <span>Discuss ideas and share experiences.</span>
                          </li>
                          <li>
                            <span>
                              book conference rooms & browse all upcoming
                              events.
                            </span>
                          </li>
                        </ul>
                        <div className="downloadApp-btn">
                          <a
                            href="https://play.google.com/store/apps/details?id=com.smartworks"
                            target="_blank"
                            onClick={() => setStore('android')}
                          >
                            <img
                              src="assets/images/store_google.svg"
                              loading="lazy"
                            />
                          </a>
                          <a
                            href="https://apps.apple.com/in/app/smartworks-mobile-app/id1489689066"
                            target="_blank"
                            onClick={() => setStore('apple')}
                          >
                            <img
                              src="assets/images/store_apple.svg"
                              loading="lazy"
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 app-image">
                      <img
                        src="assets/images/app_1.png"
                        className="img-fluid "
                        loading="lazy"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </Layout>
      </Layout>

      <SwModal
        show={isModalOpenSurvey && surveyData.length > 0}
        onClose={closeModalSurvey}
        className="CsatModal"
      >
        <div className="text-center">
          <img
            src="../img/csat-survey.svg"
            className="CsatModalImage"
          />

          <h4>
            Got a minute? Help us improve by sharing your feedback
          </h4>

          <p>
            Please fill this quick survey for us to know that how we are
            doing !
          </p>
        </div>

        <div className="text-center mt-3">
          <SwButton
            variant="primary"
            href="/SurveyManagementPage"
          >
            Start Survey
          </SwButton>
        </div>
      </SwModal>

      {/* Drawer Component */}

      <Drawer_Form
        showDrawer={showDrawer}
        onClose={onClose}
        showDrawer1={showDrawer1}
        onClose1={onClose1}
        drawerType={drawerType}
        setDrawerType={setDrawerType}
        open={open}
        setOpen={setOpen}
      />
    </>
  );
}

export default DashboardV2;
